import './styles.scss';

import { Datetime } from '@/utils';
import { LoadingBlur } from '@/components/LoadingSpinner';
import Popup from '@/common/Popup';
import { createComponentState } from '@/state';
import { useEffect } from 'react';
import { useGetTripEta } from '@/api/services/trips/getTripEta';

type TripEtaPopupState = {
  target: HTMLElement | string | null | undefined;
  tripId: string;
};

const initTripEtaPopupState: TripEtaPopupState = {
  target: undefined,
  tripId: '',
};
export const useTripEtaPopupState = createComponentState(initTripEtaPopupState);

const TripEtaPopup = () => {
  // init state
  const [target, tripId, onHide] = useTripEtaPopupState(({ state: { target, tripId }, setState }) => [
    target,
    tripId,
    () => setState((current) => ({ ...current, ...initTripEtaPopupState })),
  ]);
  // init query
  const [{ data, loading }, { fetch: getTripEta }] = useGetTripEta();
  // fire query
  useEffect(() => {
    if (!tripId || loading) return;
    getTripEta(tripId).catch((err) => console.error('TripEtaPopup: getTripEta: ', err?.message || err));
  }, [tripId]);

  // return display
  return (
    <Popup.Popover className="TripEtaPopup" show={!!target} target={target} onHide={onHide} placement="right">
      <h5>Driver ETA</h5>
      <LoadingBlur loading={loading} size="md" />
      <p>
        <strong
          className={
            loading || data?.isLate === undefined || data?.isLate === null ? 'text-muted' : data?.isLate ? 'text-danger' : 'text-success'
          }
        >
          {loading ? 'Loading...' : data?.arrivesAt ? new Datetime(data?.arrivesAt).fullTime : 'Unknown'}
          {!loading && data?.arrivesAt && (
            <>
              <br />
              Arrival Time
            </>
          )}
        </strong>
      </p>
    </Popup.Popover>
  );
};

export default TripEtaPopup;
